import React, { useCallback, useContext } from "react";
import { Link } from "react-router-dom";
import { getAuth, signInWithEmailAndPassword } from "firebase/auth";
import { AuthContext } from "../auth/AuthHook";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import TextField from "@mui/material/TextField";

const Login = () => {
	const [email, setEmail] = React.useState("");
	const [password, setPassword] = React.useState("");
	const auth = getAuth();
	const handleLogin = async (event) => {
		event.preventDefault();
		try {
			await signInWithEmailAndPassword(auth, email, password);
		} catch (error) {
			console.log(error);
			alert(error);
		}
	};

	const { currentUser } = useContext(AuthContext);

	if (currentUser) {
		console.log("hellou kek");
	}

	return (
		<Box
			style={{
				position: "absolute",
				// top: 0,
				// bottom: 0,
				left: 0,
				right: 0,
				// marginTop: "auto",
				// marginBottom: "auto",
				marginLeft: "auto",
				marginRight: "auto",
				width: 300,
			}}
		>
			<h1>Log in</h1>
			<Box>
				{/* <Box></Box> */}
				<TextField
					sx={{ marginBottom: 2, minWidth: 300 }}
					id="email"
					label="Email"
					variant="outlined"
					value={email}
					onChange={(e) => setEmail(e.target.value)}
				/>
				<TextField
					sx={{ marginBottom: 2, minWidth: 300 }}
					id="my-pass"
					label="Pass"
					variant="outlined"
					value={password}
					onChange={(e) => setPassword(e.target.value)}
				/>
				<Box sx={{ padding: "auto" }}>
					<Button
						disabled={!email || !password}
						variant="outlined"
						onClick={handleLogin}
					>
						Log in
					</Button>
				</Box>
			</Box>
			{/* <form onSubmit={handleLogin}>
				<label>
					Email
					<input name="email" type="email" placeholder="Email" />
				</label>
				<label>
					Password
					<input name="password" type="password" placeholder="Password" />
				</label>
				<button type="submit">Log in</button>
			</form>
			<span className="input-group-btn">
				<Link to="/signup">Click to Signup</Link>
			</span> */}
		</Box>
	);
};

export default Login;
